module.exports = __webpack_public_path__ + "static/media/Arrow_Icon.b166272e.svg";